// ── Prononciations (recherche dynamique, BETA) ────────────────────────────────
//
// Affiche la section #dsr-prononciations ssi le mot courant possède au moins une
// traduction VERS LE FRANÇAIS (règle « pas de traduction vers le fr → pas de
// prononciation »). Le contenu — un <li> par traduction française (toutes langues
// xx→fr confondues, dédupliquées par lemme), chacun avec sa propre icône d'écoute.
//
// Source : événement 'usito:traductions-terminées' { texte, traductionsVersFr }
// émis par traductions/index.js, où traductionsVersFr est un tableau
// [{ lemme, lexieId }, …] (éventuellement vide).
//
// Ce module ne fait que RENDRE les <li> + icônes casque (class="usito-audio",
// data-audio-ref="lexie:{id}") ; le clic et l'ouverture de la modale sont pris en
// charge par le contrôleur global audio/index.js.
//
// Activation : flag BETA (window.beta === true), comme la section elle-même.

function afficherSectionPrononciations(visible) {
    const section = document.getElementById('dsr-prononciations');
    if (section) section.style.display = visible ? 'block' : 'none';
}

// (Re)construit la liste : un <li> par traduction française (lemme + icône
// d'écoute liée au lexieId, résolu côté serveur en forme-lemme).
function rendrePrononciations(traductions) {
    const section = document.getElementById('dsr-prononciations');
    if (!section) return;

    const ancienneListe = document.getElementById('dsr-prononciations-liste');
    if (ancienneListe) ancienneListe.remove();

    const ul = document.createElement('ul');
    ul.id        = 'dsr-prononciations-liste';
    ul.className = 'dsr-suggestions-liste';

    traductions.forEach(function ({ lemme, lexieId }) {
        const li = document.createElement('li');
        li.className   = 'dsr-suggestions-liste-élément';
        li.textContent = lemme;

        const icone = document.createElement('i');
        icone.className            = 'usito-audio icon i-headphones';
        icone.title               = 'Écouter le mot « ' + lemme + ' »';
        icone.dataset.audioRef     = 'lexie:' + lexieId;
        icone.dataset.audioOrigine = 'recherche';

        li.appendChild(icone);
        ul.appendChild(li);
    });

    section.appendChild(ul);
}

if (typeof window.beta !== 'undefined' && window.beta === true) {

    // Au moins une traduction vers le fr → on rend et on affiche ; sinon on masque.
    document.addEventListener('usito:traductions-terminées', function ({ detail }) {
        const traductions = (detail && detail.traductionsVersFr) || [];
        if (traductions.length > 0) {
            rendrePrononciations(traductions);
            afficherSectionPrononciations(true);
        } else {
            afficherSectionPrononciations(false);
        }
    });
}
